import React, { useEffect, useState } from "react";
import { Box, Typography, Button } from "@mui/material";
import "./LegalDocumentsSecondSection.scss";
import fblogo from "../../../assets/Images/About/fblogoblack.svg";
import linkdln from "../../../assets/Images/About/linkdlnblack.svg";
import insta from "../../../assets/Images/About/instablack.svg";
import youtube from "../../../assets/Images/About/youtubeblack.svg";
import TermsOfService from "./Content/TermsOfService";
import { useLocation } from "react-router-dom";
import DistributionAgreement from "./Content/DistributionAgreement";
import PrivacyPolicy from "./Content/PrivacyPolicy";
import AntiFraudPolicy from "./Content/AntiFraudPolicy";
import AnalyticsDisclosure from "./Content/AnalyticsDisclosure";
import ExclusiveArtist from "./Content/ExclusiveArtist";

const sections = [
  { id: 0, title: "Terms of Service", content: <TermsOfService /> },
  {
    id: 1,
    title: "Distribution Agreement",
    content: <DistributionAgreement />,
  },
  { id: 2, title: "Analytics Disclosure", content: <AnalyticsDisclosure /> },
  { id: 3, title: "Privacy Policy", content: <PrivacyPolicy /> },
  { id: 4, title: "Anti-Fraud Policy", content: <AntiFraudPolicy /> },
  { id: 5, title: "Exclusive Artist", content: <ExclusiveArtist /> },
];

const LegalDocumentsSecondSection = () => {
  const [currentSection, setCurrentSection] = useState(0);

  const handleNext = () => {
    if (currentSection < sections.length - 1) {
      setCurrentSection(currentSection + 1);
    }
  };

  const handlePrevious = () => {
    if (currentSection > 0) {
      setCurrentSection(currentSection - 1);
    }
  };

  const location = useLocation();
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const sectionId = parseInt(params.get("section"));

    if (!isNaN(sectionId) && sectionId >= 0 && sectionId < sections.length) {
      setCurrentSection(sectionId);
    }
  }, [location]);
  return (
    <Box className="legal-documents-section">
      <Box className="content-section">
        <Box className="side-menu">
          <Typography variant="h6" className="menu-title">
            Legal Documents
          </Typography>
          {sections.map((sec, i) => (
            <Typography
              key={sec.id}
              className={`menu-item ${currentSection === i ? "active" : ""}`}
              onClick={() => setCurrentSection(i)}>
              {sec.title}
              {currentSection === i && <div className="active-line"></div>}
            </Typography>
          ))}
        </Box>

        <Box className="content">
          <Typography variant="h4" className="content-title">
            {sections[currentSection].title}
          </Typography>
          <Typography className="content-text">
            {sections[currentSection].content}
          </Typography>

          <Box></Box>
          <Box className="navigation-buttons">
            <Button
              className="nav-button"
              onClick={handlePrevious}
              disabled={currentSection === 0}>
              Previous Page
            </Button>
            <Button
              className="nav-button"
              onClick={handleNext}
              disabled={currentSection === sections.length - 1}>
              Next Page
            </Button>
          </Box>

          <Box className="contact-us">
            <Typography variant="h5" className="contact-title">
              Contact Us
            </Typography>
            <Typography className="contact-text">
              Got questions or need support? We’re here to help! Reach out to us
              via any of the following channels:
            </Typography>
            <Box className="contact-info">
              <Typography>Email: info@fmdigitalofficial.com</Typography>
              <Typography>Website: www.fmdigitalofficial.com</Typography>
            </Box>
            <Box className="social-links">
              <a
                href="https://in.linkedin.com/company/fmdigitalofficial"
                target="_blank"
                rel="noopener noreferrer">
                <img
                  src={linkdln}
                  alt="LinkedIn Logo"
                  style={{ color: "black" }}
                />
              </a>
              <a
                href=" https://www.instagram.com/fmdigitalofficial/ fmdigitalofficial/"
                target="_blank"
                rel="noopener noreferrer">
                <img src={insta} alt="Instagram Logo" />
              </a>
              {/* <a href="https://www.facebook.com/FMDigital2/ FMDigital2/" target="_blank" rel="noopener noreferrer">
                                <img src={fblogo} alt="Facebook Logo" />
                            </a> */}
              <a
                href="https://www.youtube.com/@fm_digital"
                target="_blank"
                rel="noopener noreferrer">
                <img src={youtube} alt="YouTube Logo" />
              </a>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default LegalDocumentsSecondSection;
